"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsDepartementMapContextInfo", function () {
    return {
        restrict: "E",
        require: "^obsDepartementManager",
        scope: true,
        replace: true,
        template: require("./obsDepartementMapContextInfo.html")
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/departement/obsDepartementMapContextInfo.js